import * as React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@material-ui/core";
import {deleteList, isErrorResponse} from "../../util/api";
import {useDispatch} from "react-redux";
import {
    DeleteSNSList,
    DemoDeleteSNSList,
    UpdateErrorSnackBar,
    UpdateSuccessSnackBar,
} from "../../actions";

type DeleteListModalProps = {
    isOpen: boolean;
    setOpen: (open: boolean) => void;
    selectedList: number;
    isDemo?: boolean;
};

export const DeleteListModal: React.FC<DeleteListModalProps> = (
    props: DeleteListModalProps
) => {
    const {isOpen, setOpen, selectedList, isDemo} = props;
    const [isLoading, setIsLoading] = React.useState(false);

    const dispatch = useDispatch();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteList = async () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        if (!isDemo) {
            const res = await deleteList(selectedList);
            if (isErrorResponse(res)) {
                dispatch(UpdateErrorSnackBar("リストの削除に失敗しました。"));
                setIsLoading(false);
                return;
            }
            dispatch(DeleteSNSList(selectedList));
        } else {
            dispatch(DemoDeleteSNSList(selectedList));
        }
        dispatch(UpdateSuccessSnackBar("リストを削除しました"));
        setIsLoading(false);
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"リスト削除"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        本当にリストを削除しますか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        キャンセル
                    </Button>
                    <Button
                        onClick={handleDeleteList}
                        color="primary"
                        style={{
                            backgroundColor: "red",
                            color: "white",
                            fontWeight: "bold",
                        }}
                        autoFocus
                    >
                        {isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "削除"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
